import React from 'react';
import {
  Snackbar,
  Alert,
  Button,
  Box,
  Typography
} from '@mui/material';
import {
  SystemUpdateAlt as UpdateIcon
} from '@mui/icons-material';
import usePWAUpdate from '../hooks/usePWAUpdate';

/**
 * PWA Update Notification Component
 * Shows a persistent snackbar when a new version is available
 * Can be placed in App.js to show across all pages
 */
const UpdateNotification = () => {
  const { updateAvailable, applyUpdate } = usePWAUpdate();

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ 
        '& .MuiSnackbarContent-root': { 
          minWidth: '350px',
          padding: 0
        } 
      }}
    >
      <Alert
        severity="info"
        icon={<UpdateIcon sx={{ fontSize: 28 }} />}
        sx={{
          width: '100%',
          backgroundColor: '#667eea',
          color: 'white',
          alignItems: 'center',
          padding: 2,
          '& .MuiAlert-icon': {
            color: 'white'
          }
        }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={applyUpdate}
            variant="outlined"
            sx={{
              borderColor: 'white',
              color: 'white',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderColor: 'white'
              }
            }}
          >
            تحديث الآن
          </Button>
        }
      >
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            تحديث جديد متوفر!
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '0.85rem', opacity: 0.95 }}>
            إصدار جديد متاح. اضغط "تحديث الآن" للحصول على أحدث الميزات
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default UpdateNotification;
